import React from 'react';
import { Box, Typography } from '@mui/material';
import styled from "@emotion/styled";
import { keyframes } from '@emotion/react';

interface BubbleBoxComponentProps {
    message: string;
}

const bounce = keyframes`
    0% {
        transform: translateY(0);
    }
    50% {
        transform: translateY(-10px);
    }
    100% {
        transform: translateY(0);
    }
`;


export const BubbleBox = styled(Box)(
    ({ theme }) => {
        return {
            background: 'white',
            borderRadius: '40px',
            padding: '16px',
            position: 'relative',
            maxWidth: '300px',
            boxShadow: '0px 8px 10px rgba(0, 0, 0, 0.3), 0px 4px 20px rgba(0, 0, 0, 0.22)',
            border: '4px solid black',  /* Thick black stroke */
            animation: `${bounce} 2s infinite`,
            animationTimingFunction: "ease-in-out",
        }
    }

);


const BubbleBoxComponent: React.FC<BubbleBoxComponentProps> = ({ message }) => {
    return (
        <BubbleBox>
            <Typography>{message}</Typography>
        </BubbleBox>
    );
};

export default BubbleBoxComponent;